/**
 * @generated SignedSource<<f0fd0a7d91b103a8c4654b3e7dcdcfaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EcommerceSettingsInput = {
  accessKey?: string | null;
  accessSecret?: string | null;
  adminPath?: string | null;
  apiKey?: string | null;
  apiSecret?: string | null;
  currencyGlobalID?: string | null;
  ecommerceGlobalID: string;
  productsApi?: string | null;
  recaptchaToken: string;
  remoteUrl?: string | null;
  salesChannelID?: string | null;
  siteId?: string | null;
};
export type blankApiIntegrationSalesChannelDialogInsertIntegrationMutation$variables = {
  input: EcommerceSettingsInput;
};
export type blankApiIntegrationSalesChannelDialogInsertIntegrationMutation$data = {
  readonly saveEcommerceSettings: {
    readonly ecommerceID: number;
  } | null;
};
export type blankApiIntegrationSalesChannelDialogInsertIntegrationMutation = {
  response: blankApiIntegrationSalesChannelDialogInsertIntegrationMutation$data;
  variables: blankApiIntegrationSalesChannelDialogInsertIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "settingsInput",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "blankApiIntegrationSalesChannelDialogInsertIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "blankApiIntegrationSalesChannelDialogInsertIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "303a589e12932ddd3a702ed4c73ae6ac",
    "id": null,
    "metadata": {},
    "name": "blankApiIntegrationSalesChannelDialogInsertIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation blankApiIntegrationSalesChannelDialogInsertIntegrationMutation(\n  $input: EcommerceSettingsInput!\n) {\n  saveEcommerceSettings(settingsInput: $input) {\n    ecommerceID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "90cc72a62cc174da4e8306dc2eca193b";

export default node;
